"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyfill = void 0;
var js_sdk_1 = require("../models/js-sdk");
var noOp = function () { }; // tslint:disable-line:no-empty
exports.polyfill = {
    Analytics: {
        trackEvent: noOp,
    },
    logOutCurrentMember: noOp,
    getSiteInfo: function (callback) { return callback({
        baseUrl: 'https://mnmteam.wixsite.com/mysite-122',
        pageTitle: 'mysite-122 | Members',
        pageTitleOnly: 'Members',
        referer: '',
        siteDescription: '',
        siteKeywords: '',
        url: 'https://mnmteam.wixsite.com/mysite-122/members',
    }); },
    addEventListener: noOp,
    removeEventListener: noOp,
    closeWindow: function (callback) { return ({ someData: true }); },
    requestLogin: function (options, callback, error) { return callback({
        authResponse: true,
        data: {
            admin: false,
            attributes: {
                emailVerified: true,
                firstName: null,
                imageUrl: null,
                lastName: null,
                name: null,
                nickname: 'niceman',
                privacyStatus: 'PRIVATE',
            },
            collectionId: '137b7a5d-e18d-402d-945e-44fbd2d50235',
            contactId: 'a4900548-da24-457a-a2fd-e178caa28509',
            dateCreated: '2018-10-04T07:10:17.000Z',
            dateUpdated: '2018-10-04T07:10:16.885Z',
            email: 'niceman@nice.com',
            id: 'a4900548-da24-457a-a2fd-e178caa28509',
            memberRole: 'MEMBER',
            name: null,
            owner: false,
            slug: 'niceman',
            status: 'ACTIVE',
        },
    }); },
    currentMember: function (callback) { return callback({
        name: 'Some Person',
        email: 'some@person.com',
        id: 'some-person-1',
        owner: false,
    }); },
    setHeight: noOp,
    navigateTo: function (page, onFailure) { return undefined; },
    WindowOrigin: {
        ABSOLUTE: 'ABSOLUTE',
        DEFAULT: 'FIXED',
        FIXED: 'FIXED',
        RELATIVE: 'RELATIVE',
    },
    getSiteMap: function (callback) { return callback([
        {
            hidden: false,
            isHomePage: true,
            pageId: '#qz9ga',
            title: 'Home',
            type: 'PageLink',
            url: 'http://mnmteam.wixsite.com/members-local',
        },
    ]); },
    navigateToPage: noOp,
    Events: {
        EDIT_MODE_CHANGE: 'EDIT_MODE_CHANGE',
        PAGE_NAVIGATION_CHANGE: 'PAGE_NAVIGATION_CHANGE',
        SITE_PUBLISHED: 'SITE_PUBLISHED',
        COMPONENT_DELETED: 'COMPONENT_DELETED',
        SETTINGS_UPDATED: 'SETTINGS_UPDATED',
        WINDOW_PLACEMENT_CHANGED: 'WINDOW_PLACEMENT_CHANGED',
        ON_MESSAGE_RESPONSE: 'ON_MESSAGE_RESPONSE',
        THEME_CHANGE: 'THEME_CHANGE',
        STYLE_PARAMS_CHANGE: 'STYLE_PARAMS_CHANGE',
        SCROLL: 'SCROLL',
        PAGE_NAVIGATION: 'PAGE_NAVIGATION',
        PAGE_NAVIGATION_IN: 'PAGE_NAVIGATION_IN',
        PAGE_NAVIGATION_OUT: 'PAGE_NAVIGATION_OUT',
        STATE_CHANGED: 'STATE_CHANGED',
        DEVICE_TYPE_CHANGED: 'DEVICE_TYPE_CHANGED',
        KEY_DOWN: 'KEY_DOWN',
        KEY_UP: 'KEY_UP',
        SITE_SAVED: 'SITE_SAVED',
        SESSION_CHANGED: 'SESSION_CHANGED',
        MEMBER_DETAILS_UPDATED: 'MEMBER_DETAILS_UPDATED',
        PUBLIC_DATA_CHANGED: 'PUBLIC_DATA_CHANGED',
        SITE_METADATA_CHANGED: 'SITE_METADATA_CHANGED',
        QUICK_ACTION_TRIGGERED: 'QUICK_ACTION_TRIGGERED',
        INSTANCE_CHANGED: 'INSTANCE_CHANGED',
    },
    PubSub: {
        publish: noOp,
        subscribe: function (eventName, callback) { return callback({
            name: eventName,
            data: {},
            origin: 'abcd-1234',
        }); },
    },
    Data: {
        Public: {
            set: function (key, value, options, callback) { return undefined; },
            get: function (key, options, callback) { return undefined; },
        },
    },
    Styles: {
        getStyleParams: function () { return ({
            booleans: {},
            colors: {},
            fonts: {},
            numbers: {},
            googleFontsCssUrl: '',
            uploadFontFaces: '',
        }); },
        getSiteTextPresets: function () { return ({}); },
        getSiteColors: function () { return []; },
        setBooleanParam: function () { return ({}); },
    },
    Settings: {
        getDashboardAppUrl: function (callback) { return undefined; },
        openDashboard: function (options) { return undefined; },
        triggerSettingsUpdatedEvent: function () { return undefined; },
        setFullWidth: function (fullWidth) { return undefined; },
        isFullWidth: function (callback) { return undefined; },
        closeWindow: function () { return undefined; },
        openBillingPage: function () { return undefined; },
    },
    Dashboard: {
        openBillingPage: function () { return undefined; },
    },
    Utils: {
        navigateToSection: noOp,
        getInstanceValue: function (key) { return "some-instance-value-" + key; },
        getInstanceId: function () { return 'some-instance-id'; },
        getViewMode: function () { return js_sdk_1.WixViewMode.SITE; },
        getSectionUrl: function () { return 'some-url'; },
        getSiteOwnerId: function () { return 'some-site-owner-id'; },
        getUid: function () { return 'some-uui'; },
        getLocale: function () { return 'en'; },
    },
    SuperApps: {
        getPublicAPI: function (params, callback) { return callback({}); },
        authorizeMemberPages: function (callback) { return callback(); },
    },
    Performance: {
        applicationLoaded: function () { return undefined; },
    },
    getPublicAPI: function (params, callback) { return callback({}); },
    pushState: noOp,
    replaceSectionState: noOp,
    getBoundingRectAndOffsets: function (callback) { return callback({
        rect: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            height: 0,
            width: 0,
        },
        offsets: {
            x: 0,
            y: 0,
        },
        scale: 1,
    }); },
    openModal: function (url, width, height, onClose, theme) { return undefined; },
    openPopup: function (url, width, height, position, onClose, theme) { return undefined; },
    scrollTo: function (x, y) { return undefined; },
};
//# sourceMappingURL=polyfill.js.map